<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <a type="button" class="btn-close" (click)="closeModal()">
    <i class="fa fa-close text-orange"></i>
  </a>
</div>
<div class="modal-body">
  <ng-container #dynamicContainer></ng-container>
</div>
<div class="modal-footer"><hr /></div>
